import { IHttpApi } from '@cian/http-api/shared';
import { ILogger } from '@cian/logger';
import { ResponseError } from '../errors/ResponseError';
import { fetchGetSeoData, TGetSeoDataRequest, TGetSeoDataResponse } from '../repositories/seo-urls/v1/get-seo-data';
import { ISeoPageData } from '../types/seo';
import { ApiCache, GET_SEO_DATA_API_CACHE_KEY } from './apiCache';

export async function getSeoData(
  httpApi: IHttpApi,
  logger: ILogger,
  parameters: TGetSeoDataRequest,
  seoApiCacheEnabled?: boolean,
): Promise<ISeoPageData | undefined> {
  try {
    const cacheKey = `${GET_SEO_DATA_API_CACHE_KEY}_${parameters.uri}`;
    if (seoApiCacheEnabled) {
      const cacheData = ApiCache.getData<ISeoPageData>(cacheKey);
      if (typeof cacheData !== 'undefined') {
        return cacheData;
      }
    }

    const { response, statusCode } = await fetchGetSeoData<TGetSeoDataResponse, TGetSeoDataResponse>({
      httpApi,
      parameters,
    });

    if (statusCode !== 200) {
      throw new ResponseError({
        domain: 'getSeoData',
        message: response.message,
      });
    }

    if (seoApiCacheEnabled) {
      ApiCache.setData<ISeoPageData>(cacheKey, response);
    }

    return response;
  } catch (error) {
    logger.warning(error, { degradation: 'Получение СЕО-данных' });

    return;
  }
}
